import { i18nFormat } from '@unionfab/ufc-shop-commons';
import * as S from '@unionfab/ufc-shop-commons';
import { Badge, Button } from 'antd';
import { FC } from 'react';

import { useAppNavigate } from '@/features/shared';
import { Ellipsis } from '../../../../commons/components/Element/ellipsis';
import styles from './index.module.less';

/**
 * 联系制造商按钮组件
 *
 * 用于显示联系制造商按钮，并在有新消息时显示消息数量徽章
 */
interface ContactManufacturerProps {
  order: S.ShopOrder; // 订单信息
  isQuoteTable: boolean; // 是否为报价表
  messageCount?: number; // 消息数量
  className?: string; // 自定义类名
}

export const ContactManufacturer: FC<ContactManufacturerProps> = ({
  order,
  isQuoteTable,
  messageCount = 0,
  className,
}) => {
  const nav = useAppNavigate();

  if (!order || !order.status || !order.code) {
    return null;
  }

  const { status, code } = order;

  // 判断按钮是否可见
  const isVisible = !(status === 'ORDER_CLOSED');

  if (!isVisible) {
    return null;
  }

  /**
   * 导航到订单消息页面
   */
  const goToOrderDetailForMessage = () => {
    if (isQuoteTable) {
      nav.navigateToQuoteDetailForMessage(code);
    } else {
      nav.navigateToOrderDetailForMessage(code);
    }
  };

  // 是否显示消息徽章
  const showBadge = messageCount > 0;

  return (
    <Badge count={showBadge ? messageCount : 0} overflowCount={99}>
      <Button
        className={className || styles.defaultBtn}
        onClick={goToOrderDetailForMessage}
      >
        <Ellipsis maxWidth={'100%'} style={{ lineHeight: '30px' }}>
          {i18nFormat('Contact Manufacturer')}
        </Ellipsis>
      </Button>
    </Badge>
  );
};

export default ContactManufacturer;
